import { Helmet } from "react-helmet";

import { useArtAvailable } from "../components/unfathomable/assets";
import { TooltipLayer } from "../components/unfathomable/CardFace";
import { GameTable } from "../components/unfathomable/GameTable";
import { RoomLobby, RoomPicker } from "../components/unfathomable/Lobby";
import { Toast } from "../components/unfathomable/Overlays";
import { PasswordGate } from "../components/unfathomable/PasswordGate";
import { useUnfathomableRoom } from "../components/unfathomable/useUnfathomableRoom";
import css from "../components/unfathomable/Unfathomable.module.css";
import "../components/unfathomable/fonts.css";

function UnfathomableApp() {
  return (
    <div className={css.root}>
      <Helmet><title>深渊之中 · Unfathomable</title></Helmet>
      {/* Private: the game only connects once the password gate is passed. */}
      <PasswordGate><UnfathomableGame /></PasswordGate>
    </div>
  );
}

function UnfathomableGame() {
  const conn = useUnfathomableRoom();
  const artOk = useArtAvailable();
  const msg = conn.msg;

  let body;
  if (!conn.joined || !msg) body = <RoomPicker conn={conn} />;
  else if (msg.lobby.phase === "lobby" || !msg.view) body = <RoomLobby conn={conn} lobby={msg.lobby} artOk={artOk} />;
  else body = <GameTable conn={conn} msg={msg} artOk={artOk} />;

  return (
    <TooltipLayer>
      {body}
      <Toast text={conn.error} onClose={conn.clearError} />
    </TooltipLayer>
  );
}

export default UnfathomableApp;
